import React, { useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import TableOfContents from './TableOfContents/TableOfContents';
import Introduction from '../../components/PolicyParts/Introduction';
import InformationWeCollect from '../../components/PolicyParts/InformationWeCollect';
import ProcessingAndLegalBasis from '../../components/PolicyParts/ProcessingAndLegalBasis';
import Cookies from '../../components/PolicyParts/Cookies';
import ThirdParties from '../../components/PolicyParts/ThirdParties';
import DataRetentionPeriods from '../../components/PolicyParts/DataRetentionPeriods';
import International from '../../components/PolicyParts/International';
import DataPrivacyRights from '../../components/PolicyParts/DataPrivacyRights';
import './privacyNotice.css';

const PrivacyNotice = () => {
    const [section, setSection] = useState('Introduction');

    const componentsMap = {
      'Introduction': <Introduction />,
      'Information We Collect': <InformationWeCollect />,
      'Processing and Legal Basis': <ProcessingAndLegalBasis />,
      'Cookies': <Cookies />,
      'Third Parties': <ThirdParties />,
      'International Data Transfers': <International />,
      'Data Retention Periods': <DataRetentionPeriods />,
      'Data Subject Rights' : <DataPrivacyRights />
    };

    const handleEnter = () => {
        const sectionContent = document.querySelector('.section-content');
        if (sectionContent) {
            sectionContent.style.overflow = 'hidden';
        }
    };

    const handleExited = () => {
        const sectionContent = document.querySelector('.section-content');
        if (sectionContent) {
            sectionContent.style.overflow = 'hidden';
        }
    };

    return (
        <div className="notice">
            <div className='notice-content'>
                <div className="content-flex">
                    <div className='table'>
                        <TableOfContents sections={Object.keys(componentsMap)} setSection={setSection} selectedSection={section} />
                    </div>
                    <div className="section-content">
                        <TransitionGroup>
                            <CSSTransition
                                key={section}
                                timeout={{ enter: 500, exit: 500 }}
                                classNames="item"
                                onEnter={handleEnter}
                                onExited={handleExited}
                            >
                                <div>{componentsMap[section]}</div>
                            </CSSTransition>
                        </TransitionGroup>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyNotice;
